import { call, takeLatest } from 'redux-saga/effects';
import { GlobalAction, GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';

export function* watchTarifierungTriggered() {
  yield takeLatest(GlobalActions.TARIFIERUNG_TRIGGERED, handleTarifierungTriggered);
}

export function* handleTarifierungTriggered(action: GlobalAction<unknown>) {
  const globalPut = GlobalPut.getInstance();
  yield call(globalPut.put, new GlobalActions().tarifiereShopSync(action));
}
